/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { changeResellerStatus, deleteReseller } from '../../core/_requests'
import { Link, Navigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import toast from 'react-hot-toast'
import Swal from 'sweetalert2'

type Props = {
  id: ID
  status?:any
}

const ResellerActionsCell: FC<Props> = ({ id,status }) => {
  const { setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => deleteReseller(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      toast.success('Deleted Successfully',{position:'top-right'})
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
    },
    onError:()=>{
      toast.error('Sorry The Action Failed...',{position:'bottom-right'})
    }
  })
  const updateResellerStatus = useMutation(() => changeResellerStatus(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      toast.success(`${status == 0 ? 'Activated':'Deactivated'} Successfully`,{position:'top-right'})
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
    },
    onError:()=>{
      toast.error('Sorry Failed...',{position:'bottom-right'})
    }
  })
  const confirmDelete = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      deleteItem.mutate();
    }
  };

  const confirmStatusChange = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${status == 0 ? 'activate' : 'deactivate'} this item!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, proceed!',
    });

    if (result.isConfirmed) {
      updateResellerStatus.mutate();
    }
  };
  return (
    <>
      <a
        href='#'
        className='btn btn-primary btn-active-light-primary btn-sm '
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        style={{
          minWidth: '100px', // Set a minimum width to prevent wrapping
          fontSize: '11px', // Adjust font size if needed
        }}
      >
        <FormattedMessage id='TABLE.GENERAL.ACTION' />
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <Link to={`overview/${id}/view`} className='menu-link px-3'>
            <FormattedMessage id='TABLE.GENERAL.VIEW' />      </Link>
        </div>
        {/* end::Menu item */}
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            <FormattedMessage id='TABLE.GENERAL.EDIT' />
          </a>
        </div>
        {/* end::Menu item */}

        
        {/* begin::Menu item */}
        {(status == 0) && (

        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-resellers-table-filter='delete_row'
            onClick={async () => await confirmStatusChange()}
          >
            <FormattedMessage id='TABLE.GENERAL.ACTIVATE' />
          </a>
        </div>
        )}
        {/* end::Menu item */}
                {/* begin::Menu item */}
                {(status == 1) && (

                <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-resellers-table-filter='delete_row'
            onClick={async () => await confirmStatusChange()}
          >
            <FormattedMessage id='TABLE.GENERAL.DEACTIVATE' />
          </a>
        </div>
                )}
        {/* end::Menu item */}
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-resellers-table-filter='delete_row'
            onClick={async () => await confirmDelete()}
          >
            <FormattedMessage id='TABLE.GENERAL.DELETE' />
          </a>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export { ResellerActionsCell }
